import { render, staticRenderFns } from "./RiskMatrix.vue?vue&type=template&id=bf575184"
import script from "./RiskMatrix.vue?vue&type=script&lang=js"
export * from "./RiskMatrix.vue?vue&type=script&lang=js"
import style0 from "./RiskMatrix.vue?vue&type=style&index=0&id=bf575184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports